/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const sendDeviceMsg = /* GraphQL */ `
  mutation SendDeviceMsg($input: DeviceMsgInput!) {
    sendDeviceMsg(input: $input) {
      statusCode
      __typename
    }
  }
`;
export const uploadEquipments = /* GraphQL */ `
  mutation UploadEquipments($input: UploadEquipmentsInput!) {
    uploadEquipments(input: $input) {
      success
      message
      error
      __typename
    }
  }
`;
export const exportServiceOrder = /* GraphQL */ `
  mutation ExportServiceOrder($input: ExportServiceOrderInput!) {
    exportServiceOrder(input: $input) {
      success
      url
      error
      __typename
    }
  }
`;
export const exportServiceOrderList = /* GraphQL */ `
  mutation ExportServiceOrderList($input: ExportServiceOrderListInput!) {
    exportServiceOrderList(input: $input) {
      success
      url
      error
      __typename
    }
  }
`;
export const createRecipe = /* GraphQL */ `
  mutation CreateRecipe(
    $input: CreateRecipeInput!
    $condition: ModelRecipeConditionInput
  ) {
    createRecipe(input: $input, condition: $condition) {
      id
      companyID
      name
      code
      date
      type
      recipeDetails
      inputId
      availableInventoryQuantity
      inventoryUnit
      inputQuantityToUse
      applicationUnit
      preparationProcedure
      performedById
      status
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRecipe = /* GraphQL */ `
  mutation UpdateRecipe(
    $input: UpdateRecipeInput!
    $condition: ModelRecipeConditionInput
  ) {
    updateRecipe(input: $input, condition: $condition) {
      id
      companyID
      name
      code
      date
      type
      recipeDetails
      inputId
      availableInventoryQuantity
      inventoryUnit
      inputQuantityToUse
      applicationUnit
      preparationProcedure
      performedById
      status
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRecipe = /* GraphQL */ `
  mutation DeleteRecipe(
    $input: DeleteRecipeInput!
    $condition: ModelRecipeConditionInput
  ) {
    deleteRecipe(input: $input, condition: $condition) {
      id
      companyID
      name
      code
      date
      type
      recipeDetails
      inputId
      availableInventoryQuantity
      inventoryUnit
      inputQuantityToUse
      applicationUnit
      preparationProcedure
      performedById
      status
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTree = /* GraphQL */ `
  mutation CreateTree(
    $input: CreateTreeInput!
    $condition: ModelTreeConditionInput
  ) {
    createTree(input: $input, condition: $condition) {
      id
      companyID
      name
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTree = /* GraphQL */ `
  mutation UpdateTree(
    $input: UpdateTreeInput!
    $condition: ModelTreeConditionInput
  ) {
    updateTree(input: $input, condition: $condition) {
      id
      companyID
      name
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTree = /* GraphQL */ `
  mutation DeleteTree(
    $input: DeleteTreeInput!
    $condition: ModelTreeConditionInput
  ) {
    deleteTree(input: $input, condition: $condition) {
      id
      companyID
      name
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFarm = /* GraphQL */ `
  mutation CreateFarm(
    $input: CreateFarmInput!
    $condition: ModelFarmConditionInput
  ) {
    createFarm(input: $input, condition: $condition) {
      id
      name
      location
      sizeM2
      averageAltitudeM
      responsiblePersonId
      photoEvidence
      blueprints
      description
      companyID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFarm = /* GraphQL */ `
  mutation UpdateFarm(
    $input: UpdateFarmInput!
    $condition: ModelFarmConditionInput
  ) {
    updateFarm(input: $input, condition: $condition) {
      id
      name
      location
      sizeM2
      averageAltitudeM
      responsiblePersonId
      photoEvidence
      blueprints
      description
      companyID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFarm = /* GraphQL */ `
  mutation DeleteFarm(
    $input: DeleteFarmInput!
    $condition: ModelFarmConditionInput
  ) {
    deleteFarm(input: $input, condition: $condition) {
      id
      name
      location
      sizeM2
      averageAltitudeM
      responsiblePersonId
      photoEvidence
      blueprints
      description
      companyID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLot = /* GraphQL */ `
  mutation CreateLot(
    $input: CreateLotInput!
    $condition: ModelLotConditionInput
  ) {
    createLot(input: $input, condition: $condition) {
      id
      farmID
      lotNumber
      name
      sizeM2
      perimeterM
      location
      status
      cropTypeId
      cropUnits
      performedById
      quantity
      photoEvidence
      blueprints
      description
      companyID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLot = /* GraphQL */ `
  mutation UpdateLot(
    $input: UpdateLotInput!
    $condition: ModelLotConditionInput
  ) {
    updateLot(input: $input, condition: $condition) {
      id
      farmID
      lotNumber
      name
      sizeM2
      perimeterM
      location
      status
      cropTypeId
      cropUnits
      performedById
      quantity
      photoEvidence
      blueprints
      description
      companyID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLot = /* GraphQL */ `
  mutation DeleteLot(
    $input: DeleteLotInput!
    $condition: ModelLotConditionInput
  ) {
    deleteLot(input: $input, condition: $condition) {
      id
      farmID
      lotNumber
      name
      sizeM2
      perimeterM
      location
      status
      cropTypeId
      cropUnits
      performedById
      quantity
      photoEvidence
      blueprints
      description
      companyID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLotPhoto = /* GraphQL */ `
  mutation CreateLotPhoto(
    $input: CreateLotPhotoInput!
    $condition: ModelLotPhotoConditionInput
  ) {
    createLotPhoto(input: $input, condition: $condition) {
      id
      lotID
      key
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLotPhoto = /* GraphQL */ `
  mutation UpdateLotPhoto(
    $input: UpdateLotPhotoInput!
    $condition: ModelLotPhotoConditionInput
  ) {
    updateLotPhoto(input: $input, condition: $condition) {
      id
      lotID
      key
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLotPhoto = /* GraphQL */ `
  mutation DeleteLotPhoto(
    $input: DeleteLotPhotoInput!
    $condition: ModelLotPhotoConditionInput
  ) {
    deleteLotPhoto(input: $input, condition: $condition) {
      id
      lotID
      key
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCropType = /* GraphQL */ `
  mutation CreateCropType(
    $input: CreateCropTypeInput!
    $condition: ModelCropTypeConditionInput
  ) {
    createCropType(input: $input, condition: $condition) {
      id
      name
      companyID
      cropUnitID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCropType = /* GraphQL */ `
  mutation UpdateCropType(
    $input: UpdateCropTypeInput!
    $condition: ModelCropTypeConditionInput
  ) {
    updateCropType(input: $input, condition: $condition) {
      id
      name
      companyID
      cropUnitID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCropType = /* GraphQL */ `
  mutation DeleteCropType(
    $input: DeleteCropTypeInput!
    $condition: ModelCropTypeConditionInput
  ) {
    deleteCropType(input: $input, condition: $condition) {
      id
      name
      companyID
      cropUnitID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCropUnit = /* GraphQL */ `
  mutation CreateCropUnit(
    $input: CreateCropUnitInput!
    $condition: ModelCropUnitConditionInput
  ) {
    createCropUnit(input: $input, condition: $condition) {
      id
      farmID
      lotID
      name
      plantingDate
      cropType
      unitType
      quantity
      performedById
      photoEvidence
      status
      description
      companyID
      deletedAt
      drawingData
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCropUnit = /* GraphQL */ `
  mutation UpdateCropUnit(
    $input: UpdateCropUnitInput!
    $condition: ModelCropUnitConditionInput
  ) {
    updateCropUnit(input: $input, condition: $condition) {
      id
      farmID
      lotID
      name
      plantingDate
      cropType
      unitType
      quantity
      performedById
      photoEvidence
      status
      description
      companyID
      deletedAt
      drawingData
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCropUnit = /* GraphQL */ `
  mutation DeleteCropUnit(
    $input: DeleteCropUnitInput!
    $condition: ModelCropUnitConditionInput
  ) {
    deleteCropUnit(input: $input, condition: $condition) {
      id
      farmID
      lotID
      name
      plantingDate
      cropType
      unitType
      quantity
      performedById
      photoEvidence
      status
      description
      companyID
      deletedAt
      drawingData
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createExportedServiceOrder = /* GraphQL */ `
  mutation CreateExportedServiceOrder(
    $input: CreateExportedServiceOrderInput!
    $condition: ModelExportedServiceOrderConditionInput
  ) {
    createExportedServiceOrder(input: $input, condition: $condition) {
      id
      companyID
      url
      loading
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateExportedServiceOrder = /* GraphQL */ `
  mutation UpdateExportedServiceOrder(
    $input: UpdateExportedServiceOrderInput!
    $condition: ModelExportedServiceOrderConditionInput
  ) {
    updateExportedServiceOrder(input: $input, condition: $condition) {
      id
      companyID
      url
      loading
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteExportedServiceOrder = /* GraphQL */ `
  mutation DeleteExportedServiceOrder(
    $input: DeleteExportedServiceOrderInput!
    $condition: ModelExportedServiceOrderConditionInput
  ) {
    deleteExportedServiceOrder(input: $input, condition: $condition) {
      id
      companyID
      url
      loading
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSpareDocument = /* GraphQL */ `
  mutation CreateSpareDocument(
    $input: CreateSpareDocumentInput!
    $condition: ModelSpareDocumentConditionInput
  ) {
    createSpareDocument(input: $input, condition: $condition) {
      id
      spareID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSpareDocument = /* GraphQL */ `
  mutation UpdateSpareDocument(
    $input: UpdateSpareDocumentInput!
    $condition: ModelSpareDocumentConditionInput
  ) {
    updateSpareDocument(input: $input, condition: $condition) {
      id
      spareID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSpareDocument = /* GraphQL */ `
  mutation DeleteSpareDocument(
    $input: DeleteSpareDocumentInput!
    $condition: ModelSpareDocumentConditionInput
  ) {
    deleteSpareDocument(input: $input, condition: $condition) {
      id
      spareID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createToolDocument = /* GraphQL */ `
  mutation CreateToolDocument(
    $input: CreateToolDocumentInput!
    $condition: ModelToolDocumentConditionInput
  ) {
    createToolDocument(input: $input, condition: $condition) {
      id
      toolID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateToolDocument = /* GraphQL */ `
  mutation UpdateToolDocument(
    $input: UpdateToolDocumentInput!
    $condition: ModelToolDocumentConditionInput
  ) {
    updateToolDocument(input: $input, condition: $condition) {
      id
      toolID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteToolDocument = /* GraphQL */ `
  mutation DeleteToolDocument(
    $input: DeleteToolDocumentInput!
    $condition: ModelToolDocumentConditionInput
  ) {
    deleteToolDocument(input: $input, condition: $condition) {
      id
      toolID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEquipmentPhoto = /* GraphQL */ `
  mutation CreateEquipmentPhoto(
    $input: CreateEquipmentPhotoInput!
    $condition: ModelEquipmentPhotoConditionInput
  ) {
    createEquipmentPhoto(input: $input, condition: $condition) {
      id
      equipmentID
      photo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEquipmentPhoto = /* GraphQL */ `
  mutation UpdateEquipmentPhoto(
    $input: UpdateEquipmentPhotoInput!
    $condition: ModelEquipmentPhotoConditionInput
  ) {
    updateEquipmentPhoto(input: $input, condition: $condition) {
      id
      equipmentID
      photo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEquipmentPhoto = /* GraphQL */ `
  mutation DeleteEquipmentPhoto(
    $input: DeleteEquipmentPhotoInput!
    $condition: ModelEquipmentPhotoConditionInput
  ) {
    deleteEquipmentPhoto(input: $input, condition: $condition) {
      id
      equipmentID
      photo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSparePhoto = /* GraphQL */ `
  mutation CreateSparePhoto(
    $input: CreateSparePhotoInput!
    $condition: ModelSparePhotoConditionInput
  ) {
    createSparePhoto(input: $input, condition: $condition) {
      id
      spareID
      photo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSparePhoto = /* GraphQL */ `
  mutation UpdateSparePhoto(
    $input: UpdateSparePhotoInput!
    $condition: ModelSparePhotoConditionInput
  ) {
    updateSparePhoto(input: $input, condition: $condition) {
      id
      spareID
      photo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSparePhoto = /* GraphQL */ `
  mutation DeleteSparePhoto(
    $input: DeleteSparePhotoInput!
    $condition: ModelSparePhotoConditionInput
  ) {
    deleteSparePhoto(input: $input, condition: $condition) {
      id
      spareID
      photo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createToolPhoto = /* GraphQL */ `
  mutation CreateToolPhoto(
    $input: CreateToolPhotoInput!
    $condition: ModelToolPhotoConditionInput
  ) {
    createToolPhoto(input: $input, condition: $condition) {
      id
      toolID
      photo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateToolPhoto = /* GraphQL */ `
  mutation UpdateToolPhoto(
    $input: UpdateToolPhotoInput!
    $condition: ModelToolPhotoConditionInput
  ) {
    updateToolPhoto(input: $input, condition: $condition) {
      id
      toolID
      photo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteToolPhoto = /* GraphQL */ `
  mutation DeleteToolPhoto(
    $input: DeleteToolPhotoInput!
    $condition: ModelToolPhotoConditionInput
  ) {
    deleteToolPhoto(input: $input, condition: $condition) {
      id
      toolID
      photo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createServiceOrderLog = /* GraphQL */ `
  mutation CreateServiceOrderLog(
    $input: CreateServiceOrderLogInput!
    $condition: ModelServiceOrderLogConditionInput
  ) {
    createServiceOrderLog(input: $input, condition: $condition) {
      id
      serviceOrderID
      status
      assignedExecutor
      userID
      createdAt
      companyID
      updatedAt
      __typename
    }
  }
`;
export const updateServiceOrderLog = /* GraphQL */ `
  mutation UpdateServiceOrderLog(
    $input: UpdateServiceOrderLogInput!
    $condition: ModelServiceOrderLogConditionInput
  ) {
    updateServiceOrderLog(input: $input, condition: $condition) {
      id
      serviceOrderID
      status
      assignedExecutor
      userID
      createdAt
      companyID
      updatedAt
      __typename
    }
  }
`;
export const deleteServiceOrderLog = /* GraphQL */ `
  mutation DeleteServiceOrderLog(
    $input: DeleteServiceOrderLogInput!
    $condition: ModelServiceOrderLogConditionInput
  ) {
    deleteServiceOrderLog(input: $input, condition: $condition) {
      id
      serviceOrderID
      status
      assignedExecutor
      userID
      createdAt
      companyID
      updatedAt
      __typename
    }
  }
`;
export const createEquipmentTypeDocument = /* GraphQL */ `
  mutation CreateEquipmentTypeDocument(
    $input: CreateEquipmentTypeDocumentInput!
    $condition: ModelEquipmentTypeDocumentConditionInput
  ) {
    createEquipmentTypeDocument(input: $input, condition: $condition) {
      id
      equipmentTypeID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEquipmentTypeDocument = /* GraphQL */ `
  mutation UpdateEquipmentTypeDocument(
    $input: UpdateEquipmentTypeDocumentInput!
    $condition: ModelEquipmentTypeDocumentConditionInput
  ) {
    updateEquipmentTypeDocument(input: $input, condition: $condition) {
      id
      equipmentTypeID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEquipmentTypeDocument = /* GraphQL */ `
  mutation DeleteEquipmentTypeDocument(
    $input: DeleteEquipmentTypeDocumentInput!
    $condition: ModelEquipmentTypeDocumentConditionInput
  ) {
    deleteEquipmentTypeDocument(input: $input, condition: $condition) {
      id
      equipmentTypeID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEquipmentTypeParameter = /* GraphQL */ `
  mutation CreateEquipmentTypeParameter(
    $input: CreateEquipmentTypeParameterInput!
    $condition: ModelEquipmentTypeParameterConditionInput
  ) {
    createEquipmentTypeParameter(input: $input, condition: $condition) {
      id
      equipmentTypeID
      parameterID
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEquipmentTypeParameter = /* GraphQL */ `
  mutation UpdateEquipmentTypeParameter(
    $input: UpdateEquipmentTypeParameterInput!
    $condition: ModelEquipmentTypeParameterConditionInput
  ) {
    updateEquipmentTypeParameter(input: $input, condition: $condition) {
      id
      equipmentTypeID
      parameterID
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEquipmentTypeParameter = /* GraphQL */ `
  mutation DeleteEquipmentTypeParameter(
    $input: DeleteEquipmentTypeParameterInput!
    $condition: ModelEquipmentTypeParameterConditionInput
  ) {
    deleteEquipmentTypeParameter(input: $input, condition: $condition) {
      id
      equipmentTypeID
      parameterID
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEquipmentType = /* GraphQL */ `
  mutation CreateEquipmentType(
    $input: CreateEquipmentTypeInput!
    $condition: ModelEquipmentTypeConditionInput
  ) {
    createEquipmentType(input: $input, condition: $condition) {
      id
      name
      description
      companies
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEquipmentType = /* GraphQL */ `
  mutation UpdateEquipmentType(
    $input: UpdateEquipmentTypeInput!
    $condition: ModelEquipmentTypeConditionInput
  ) {
    updateEquipmentType(input: $input, condition: $condition) {
      id
      name
      description
      companies
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEquipmentType = /* GraphQL */ `
  mutation DeleteEquipmentType(
    $input: DeleteEquipmentTypeInput!
    $condition: ModelEquipmentTypeConditionInput
  ) {
    deleteEquipmentType(input: $input, condition: $condition) {
      id
      name
      description
      companies
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUploadEquipmentLog = /* GraphQL */ `
  mutation CreateUploadEquipmentLog(
    $input: CreateUploadEquipmentLogInput!
    $condition: ModelUploadEquipmentLogConditionInput
  ) {
    createUploadEquipmentLog(input: $input, condition: $condition) {
      id
      companyID
      completed
      loading
      error
      equipmentsSucceed
      equipmentsFailed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUploadEquipmentLog = /* GraphQL */ `
  mutation UpdateUploadEquipmentLog(
    $input: UpdateUploadEquipmentLogInput!
    $condition: ModelUploadEquipmentLogConditionInput
  ) {
    updateUploadEquipmentLog(input: $input, condition: $condition) {
      id
      companyID
      completed
      loading
      error
      equipmentsSucceed
      equipmentsFailed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUploadEquipmentLog = /* GraphQL */ `
  mutation DeleteUploadEquipmentLog(
    $input: DeleteUploadEquipmentLogInput!
    $condition: ModelUploadEquipmentLogConditionInput
  ) {
    deleteUploadEquipmentLog(input: $input, condition: $condition) {
      id
      companyID
      completed
      loading
      error
      equipmentsSucceed
      equipmentsFailed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createServiceOrderPhoto = /* GraphQL */ `
  mutation CreateServiceOrderPhoto(
    $input: CreateServiceOrderPhotoInput!
    $condition: ModelServiceOrderPhotoConditionInput
  ) {
    createServiceOrderPhoto(input: $input, condition: $condition) {
      id
      serviceOrderID
      photo
      tag
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateServiceOrderPhoto = /* GraphQL */ `
  mutation UpdateServiceOrderPhoto(
    $input: UpdateServiceOrderPhotoInput!
    $condition: ModelServiceOrderPhotoConditionInput
  ) {
    updateServiceOrderPhoto(input: $input, condition: $condition) {
      id
      serviceOrderID
      photo
      tag
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteServiceOrderPhoto = /* GraphQL */ `
  mutation DeleteServiceOrderPhoto(
    $input: DeleteServiceOrderPhotoInput!
    $condition: ModelServiceOrderPhotoConditionInput
  ) {
    deleteServiceOrderPhoto(input: $input, condition: $condition) {
      id
      serviceOrderID
      photo
      tag
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createExecutedServiceOrder = /* GraphQL */ `
  mutation CreateExecutedServiceOrder(
    $input: CreateExecutedServiceOrderInput!
    $condition: ModelExecutedServiceOrderConditionInput
  ) {
    createExecutedServiceOrder(input: $input, condition: $condition) {
      id
      serviceOrderID
      userExecutor
      executedRoutines {
        equipmentID
        routineID
        activities {
          activityID
          activityValue
          activityName
          activityType
          __typename
        }
        __typename
      }
      observations
      deletedAt
      createdAt
      executionStartedAt
      executionEndedAt
      updatedAt
      __typename
    }
  }
`;
export const updateExecutedServiceOrder = /* GraphQL */ `
  mutation UpdateExecutedServiceOrder(
    $input: UpdateExecutedServiceOrderInput!
    $condition: ModelExecutedServiceOrderConditionInput
  ) {
    updateExecutedServiceOrder(input: $input, condition: $condition) {
      id
      serviceOrderID
      userExecutor
      executedRoutines {
        equipmentID
        routineID
        activities {
          activityID
          activityValue
          activityName
          activityType
          __typename
        }
        __typename
      }
      observations
      deletedAt
      createdAt
      executionStartedAt
      executionEndedAt
      updatedAt
      __typename
    }
  }
`;
export const deleteExecutedServiceOrder = /* GraphQL */ `
  mutation DeleteExecutedServiceOrder(
    $input: DeleteExecutedServiceOrderInput!
    $condition: ModelExecutedServiceOrderConditionInput
  ) {
    deleteExecutedServiceOrder(input: $input, condition: $condition) {
      id
      serviceOrderID
      userExecutor
      executedRoutines {
        equipmentID
        routineID
        activities {
          activityID
          activityValue
          activityName
          activityType
          __typename
        }
        __typename
      }
      observations
      deletedAt
      createdAt
      executionStartedAt
      executionEndedAt
      updatedAt
      __typename
    }
  }
`;
export const createActivity = /* GraphQL */ `
  mutation CreateActivity(
    $input: CreateActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    createActivity(input: $input, condition: $condition) {
      id
      name
      description
      type
      values
      abbreviation
      unit
      defaultValue
      maintenanceRoutineID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateActivity = /* GraphQL */ `
  mutation UpdateActivity(
    $input: UpdateActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    updateActivity(input: $input, condition: $condition) {
      id
      name
      description
      type
      values
      abbreviation
      unit
      defaultValue
      maintenanceRoutineID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteActivity = /* GraphQL */ `
  mutation DeleteActivity(
    $input: DeleteActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    deleteActivity(input: $input, condition: $condition) {
      id
      name
      description
      type
      values
      abbreviation
      unit
      defaultValue
      maintenanceRoutineID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMaintenanceRoutine = /* GraphQL */ `
  mutation CreateMaintenanceRoutine(
    $input: CreateMaintenanceRoutineInput!
    $condition: ModelMaintenanceRoutineConditionInput
  ) {
    createMaintenanceRoutine(input: $input, condition: $condition) {
      id
      name
      description
      activities {
        items {
          id
          name
          description
          type
          values
          abbreviation
          unit
          defaultValue
          maintenanceRoutineID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companyID
      serviceOrders {
        items {
          id
          maintenanceRoutineId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activitiesOrder
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMaintenanceRoutine = /* GraphQL */ `
  mutation UpdateMaintenanceRoutine(
    $input: UpdateMaintenanceRoutineInput!
    $condition: ModelMaintenanceRoutineConditionInput
  ) {
    updateMaintenanceRoutine(input: $input, condition: $condition) {
      id
      name
      description
      activities {
        items {
          id
          name
          description
          type
          values
          abbreviation
          unit
          defaultValue
          maintenanceRoutineID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companyID
      serviceOrders {
        items {
          id
          maintenanceRoutineId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activitiesOrder
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMaintenanceRoutine = /* GraphQL */ `
  mutation DeleteMaintenanceRoutine(
    $input: DeleteMaintenanceRoutineInput!
    $condition: ModelMaintenanceRoutineConditionInput
  ) {
    deleteMaintenanceRoutine(input: $input, condition: $condition) {
      id
      name
      description
      activities {
        items {
          id
          name
          description
          type
          values
          abbreviation
          unit
          defaultValue
          maintenanceRoutineID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companyID
      serviceOrders {
        items {
          id
          maintenanceRoutineId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activitiesOrder
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSpareParameter = /* GraphQL */ `
  mutation CreateSpareParameter(
    $input: CreateSpareParameterInput!
    $condition: ModelSpareParameterConditionInput
  ) {
    createSpareParameter(input: $input, condition: $condition) {
      id
      spareID
      parameterID
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSpareParameter = /* GraphQL */ `
  mutation UpdateSpareParameter(
    $input: UpdateSpareParameterInput!
    $condition: ModelSpareParameterConditionInput
  ) {
    updateSpareParameter(input: $input, condition: $condition) {
      id
      spareID
      parameterID
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSpareParameter = /* GraphQL */ `
  mutation DeleteSpareParameter(
    $input: DeleteSpareParameterInput!
    $condition: ModelSpareParameterConditionInput
  ) {
    deleteSpareParameter(input: $input, condition: $condition) {
      id
      spareID
      parameterID
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSpare = /* GraphQL */ `
  mutation CreateSpare(
    $input: CreateSpareInput!
    $condition: ModelSpareConditionInput
  ) {
    createSpare(input: $input, condition: $condition) {
      id
      name
      description
      status
      location
      companyID
      serviceOrderID
      equipmentID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSpare = /* GraphQL */ `
  mutation UpdateSpare(
    $input: UpdateSpareInput!
    $condition: ModelSpareConditionInput
  ) {
    updateSpare(input: $input, condition: $condition) {
      id
      name
      description
      status
      location
      companyID
      serviceOrderID
      equipmentID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSpare = /* GraphQL */ `
  mutation DeleteSpare(
    $input: DeleteSpareInput!
    $condition: ModelSpareConditionInput
  ) {
    deleteSpare(input: $input, condition: $condition) {
      id
      name
      description
      status
      location
      companyID
      serviceOrderID
      equipmentID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createToolParameter = /* GraphQL */ `
  mutation CreateToolParameter(
    $input: CreateToolParameterInput!
    $condition: ModelToolParameterConditionInput
  ) {
    createToolParameter(input: $input, condition: $condition) {
      id
      toolID
      parameterID
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateToolParameter = /* GraphQL */ `
  mutation UpdateToolParameter(
    $input: UpdateToolParameterInput!
    $condition: ModelToolParameterConditionInput
  ) {
    updateToolParameter(input: $input, condition: $condition) {
      id
      toolID
      parameterID
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteToolParameter = /* GraphQL */ `
  mutation DeleteToolParameter(
    $input: DeleteToolParameterInput!
    $condition: ModelToolParameterConditionInput
  ) {
    deleteToolParameter(input: $input, condition: $condition) {
      id
      toolID
      parameterID
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTool = /* GraphQL */ `
  mutation CreateTool(
    $input: CreateToolInput!
    $condition: ModelToolConditionInput
  ) {
    createTool(input: $input, condition: $condition) {
      id
      name
      description
      location
      companyID
      technicianID
      serviceOrders {
        items {
          id
          toolId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTool = /* GraphQL */ `
  mutation UpdateTool(
    $input: UpdateToolInput!
    $condition: ModelToolConditionInput
  ) {
    updateTool(input: $input, condition: $condition) {
      id
      name
      description
      location
      companyID
      technicianID
      serviceOrders {
        items {
          id
          toolId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTool = /* GraphQL */ `
  mutation DeleteTool(
    $input: DeleteToolInput!
    $condition: ModelToolConditionInput
  ) {
    deleteTool(input: $input, condition: $condition) {
      id
      name
      description
      location
      companyID
      technicianID
      serviceOrders {
        items {
          id
          toolId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createManagedCompany = /* GraphQL */ `
  mutation CreateManagedCompany(
    $input: CreateManagedCompanyInput!
    $condition: ModelManagedCompanyConditionInput
  ) {
    createManagedCompany(input: $input, condition: $condition) {
      id
      parentID
      childID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateManagedCompany = /* GraphQL */ `
  mutation UpdateManagedCompany(
    $input: UpdateManagedCompanyInput!
    $condition: ModelManagedCompanyConditionInput
  ) {
    updateManagedCompany(input: $input, condition: $condition) {
      id
      parentID
      childID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteManagedCompany = /* GraphQL */ `
  mutation DeleteManagedCompany(
    $input: DeleteManagedCompanyInput!
    $condition: ModelManagedCompanyConditionInput
  ) {
    deleteManagedCompany(input: $input, condition: $condition) {
      id
      parentID
      childID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCostCenter = /* GraphQL */ `
  mutation CreateCostCenter(
    $input: CreateCostCenterInput!
    $condition: ModelCostCenterConditionInput
  ) {
    createCostCenter(input: $input, condition: $condition) {
      id
      code
      name
      companyID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCostCenter = /* GraphQL */ `
  mutation UpdateCostCenter(
    $input: UpdateCostCenterInput!
    $condition: ModelCostCenterConditionInput
  ) {
    updateCostCenter(input: $input, condition: $condition) {
      id
      code
      name
      companyID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCostCenter = /* GraphQL */ `
  mutation DeleteCostCenter(
    $input: DeleteCostCenterInput!
    $condition: ModelCostCenterConditionInput
  ) {
    deleteCostCenter(input: $input, condition: $condition) {
      id
      code
      name
      companyID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createServiceOrder = /* GraphQL */ `
  mutation CreateServiceOrder(
    $input: CreateServiceOrderInput!
    $condition: ModelServiceOrderConditionInput
  ) {
    createServiceOrder(input: $input, condition: $condition) {
      id
      code
      description
      billDate
      billValue
      billCurrency
      companyID
      branchID
      equipments {
        items {
          id
          serviceOrderId
          equipmentId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      equipmentRoutines {
        equipmentID
        routineID
        __typename
      }
      equipmentSpares {
        equipmentID
        spares
        __typename
      }
      costCenterID
      title
      color
      observations
      userExecutor
      status
      start
      end
      tools {
        items {
          id
          toolId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      spares {
        items {
          id
          name
          description
          status
          location
          companyID
          serviceOrderID
          equipmentID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      maintenanceRoutines {
        items {
          id
          maintenanceRoutineId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      auxExecutors
      geolocation
      photoRequired
      offline
      createdAt
      deletedAt
      slug
      updatedAt
      __typename
    }
  }
`;
export const updateServiceOrder = /* GraphQL */ `
  mutation UpdateServiceOrder(
    $input: UpdateServiceOrderInput!
    $condition: ModelServiceOrderConditionInput
  ) {
    updateServiceOrder(input: $input, condition: $condition) {
      id
      code
      description
      billDate
      billValue
      billCurrency
      companyID
      branchID
      equipments {
        items {
          id
          serviceOrderId
          equipmentId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      equipmentRoutines {
        equipmentID
        routineID
        __typename
      }
      equipmentSpares {
        equipmentID
        spares
        __typename
      }
      costCenterID
      title
      color
      observations
      userExecutor
      status
      start
      end
      tools {
        items {
          id
          toolId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      spares {
        items {
          id
          name
          description
          status
          location
          companyID
          serviceOrderID
          equipmentID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      maintenanceRoutines {
        items {
          id
          maintenanceRoutineId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      auxExecutors
      geolocation
      photoRequired
      offline
      createdAt
      deletedAt
      slug
      updatedAt
      __typename
    }
  }
`;
export const deleteServiceOrder = /* GraphQL */ `
  mutation DeleteServiceOrder(
    $input: DeleteServiceOrderInput!
    $condition: ModelServiceOrderConditionInput
  ) {
    deleteServiceOrder(input: $input, condition: $condition) {
      id
      code
      description
      billDate
      billValue
      billCurrency
      companyID
      branchID
      equipments {
        items {
          id
          serviceOrderId
          equipmentId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      equipmentRoutines {
        equipmentID
        routineID
        __typename
      }
      equipmentSpares {
        equipmentID
        spares
        __typename
      }
      costCenterID
      title
      color
      observations
      userExecutor
      status
      start
      end
      tools {
        items {
          id
          toolId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      spares {
        items {
          id
          name
          description
          status
          location
          companyID
          serviceOrderID
          equipmentID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      maintenanceRoutines {
        items {
          id
          maintenanceRoutineId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      auxExecutors
      geolocation
      photoRequired
      offline
      createdAt
      deletedAt
      slug
      updatedAt
      __typename
    }
  }
`;
export const createEquipmentDocument = /* GraphQL */ `
  mutation CreateEquipmentDocument(
    $input: CreateEquipmentDocumentInput!
    $condition: ModelEquipmentDocumentConditionInput
  ) {
    createEquipmentDocument(input: $input, condition: $condition) {
      id
      equipmentID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEquipmentDocument = /* GraphQL */ `
  mutation UpdateEquipmentDocument(
    $input: UpdateEquipmentDocumentInput!
    $condition: ModelEquipmentDocumentConditionInput
  ) {
    updateEquipmentDocument(input: $input, condition: $condition) {
      id
      equipmentID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEquipmentDocument = /* GraphQL */ `
  mutation DeleteEquipmentDocument(
    $input: DeleteEquipmentDocumentInput!
    $condition: ModelEquipmentDocumentConditionInput
  ) {
    deleteEquipmentDocument(input: $input, condition: $condition) {
      id
      equipmentID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEquipmentParameter = /* GraphQL */ `
  mutation CreateEquipmentParameter(
    $input: CreateEquipmentParameterInput!
    $condition: ModelEquipmentParameterConditionInput
  ) {
    createEquipmentParameter(input: $input, condition: $condition) {
      id
      equipmentID
      parameterID
      parameterName
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEquipmentParameter = /* GraphQL */ `
  mutation UpdateEquipmentParameter(
    $input: UpdateEquipmentParameterInput!
    $condition: ModelEquipmentParameterConditionInput
  ) {
    updateEquipmentParameter(input: $input, condition: $condition) {
      id
      equipmentID
      parameterID
      parameterName
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEquipmentParameter = /* GraphQL */ `
  mutation DeleteEquipmentParameter(
    $input: DeleteEquipmentParameterInput!
    $condition: ModelEquipmentParameterConditionInput
  ) {
    deleteEquipmentParameter(input: $input, condition: $condition) {
      id
      equipmentID
      parameterID
      parameterName
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEquipment = /* GraphQL */ `
  mutation CreateEquipment(
    $input: CreateEquipmentInput!
    $condition: ModelEquipmentConditionInput
  ) {
    createEquipment(input: $input, condition: $condition) {
      id
      name
      location
      description
      companyID
      branchID
      deviceID
      spares {
        items {
          id
          name
          description
          status
          location
          companyID
          serviceOrderID
          equipmentID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      serviceOrders {
        items {
          id
          serviceOrderId
          equipmentId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      coordsLat
      coordsLng
      routineID
      equipmentTypeID
      deletedAt
      slug
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEquipment = /* GraphQL */ `
  mutation UpdateEquipment(
    $input: UpdateEquipmentInput!
    $condition: ModelEquipmentConditionInput
  ) {
    updateEquipment(input: $input, condition: $condition) {
      id
      name
      location
      description
      companyID
      branchID
      deviceID
      spares {
        items {
          id
          name
          description
          status
          location
          companyID
          serviceOrderID
          equipmentID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      serviceOrders {
        items {
          id
          serviceOrderId
          equipmentId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      coordsLat
      coordsLng
      routineID
      equipmentTypeID
      deletedAt
      slug
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEquipment = /* GraphQL */ `
  mutation DeleteEquipment(
    $input: DeleteEquipmentInput!
    $condition: ModelEquipmentConditionInput
  ) {
    deleteEquipment(input: $input, condition: $condition) {
      id
      name
      location
      description
      companyID
      branchID
      deviceID
      spares {
        items {
          id
          name
          description
          status
          location
          companyID
          serviceOrderID
          equipmentID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      serviceOrders {
        items {
          id
          serviceOrderId
          equipmentId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      coordsLat
      coordsLng
      routineID
      equipmentTypeID
      deletedAt
      slug
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createParameter = /* GraphQL */ `
  mutation CreateParameter(
    $input: CreateParameterInput!
    $condition: ModelParameterConditionInput
  ) {
    createParameter(input: $input, condition: $condition) {
      id
      name
      description
      type
      values
      abbreviation
      unit
      defaultValue
      companies
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateParameter = /* GraphQL */ `
  mutation UpdateParameter(
    $input: UpdateParameterInput!
    $condition: ModelParameterConditionInput
  ) {
    updateParameter(input: $input, condition: $condition) {
      id
      name
      description
      type
      values
      abbreviation
      unit
      defaultValue
      companies
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteParameter = /* GraphQL */ `
  mutation DeleteParameter(
    $input: DeleteParameterInput!
    $condition: ModelParameterConditionInput
  ) {
    deleteParameter(input: $input, condition: $condition) {
      id
      name
      description
      type
      values
      abbreviation
      unit
      defaultValue
      companies
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createHoliday = /* GraphQL */ `
  mutation CreateHoliday(
    $input: CreateHolidayInput!
    $condition: ModelHolidayConditionInput
  ) {
    createHoliday(input: $input, condition: $condition) {
      id
      date
      name
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateHoliday = /* GraphQL */ `
  mutation UpdateHoliday(
    $input: UpdateHolidayInput!
    $condition: ModelHolidayConditionInput
  ) {
    updateHoliday(input: $input, condition: $condition) {
      id
      date
      name
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteHoliday = /* GraphQL */ `
  mutation DeleteHoliday(
    $input: DeleteHolidayInput!
    $condition: ModelHolidayConditionInput
  ) {
    deleteHoliday(input: $input, condition: $condition) {
      id
      date
      name
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRuleLog = /* GraphQL */ `
  mutation CreateRuleLog(
    $input: CreateRuleLogInput!
    $condition: ModelRuleLogConditionInput
  ) {
    createRuleLog(input: $input, condition: $condition) {
      id
      ruleID
      name
      description
      companyID
      companyName
      branchID
      branchName
      deviceID
      deviceName
      notificationsSent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRuleLog = /* GraphQL */ `
  mutation UpdateRuleLog(
    $input: UpdateRuleLogInput!
    $condition: ModelRuleLogConditionInput
  ) {
    updateRuleLog(input: $input, condition: $condition) {
      id
      ruleID
      name
      description
      companyID
      companyName
      branchID
      branchName
      deviceID
      deviceName
      notificationsSent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRuleLog = /* GraphQL */ `
  mutation DeleteRuleLog(
    $input: DeleteRuleLogInput!
    $condition: ModelRuleLogConditionInput
  ) {
    deleteRuleLog(input: $input, condition: $condition) {
      id
      ruleID
      name
      description
      companyID
      companyName
      branchID
      branchName
      deviceID
      deviceName
      notificationsSent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRule = /* GraphQL */ `
  mutation CreateRule(
    $input: CreateRuleInput!
    $condition: ModelRuleConditionInput
  ) {
    createRule(input: $input, condition: $condition) {
      id
      name
      description
      action
      actionValue
      devices {
        items {
          id
          ruleId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      smsNotifications
      wspNotifications
      emailNotifications
      conditions
      enabled
      companyID
      startSchedule
      endSchedule
      days
      execInterval
      execTime
      hourInterval
      executeOnHolidays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRule = /* GraphQL */ `
  mutation UpdateRule(
    $input: UpdateRuleInput!
    $condition: ModelRuleConditionInput
  ) {
    updateRule(input: $input, condition: $condition) {
      id
      name
      description
      action
      actionValue
      devices {
        items {
          id
          ruleId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      smsNotifications
      wspNotifications
      emailNotifications
      conditions
      enabled
      companyID
      startSchedule
      endSchedule
      days
      execInterval
      execTime
      hourInterval
      executeOnHolidays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRule = /* GraphQL */ `
  mutation DeleteRule(
    $input: DeleteRuleInput!
    $condition: ModelRuleConditionInput
  ) {
    deleteRule(input: $input, condition: $condition) {
      id
      name
      description
      action
      actionValue
      devices {
        items {
          id
          ruleId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      smsNotifications
      wspNotifications
      emailNotifications
      conditions
      enabled
      companyID
      startSchedule
      endSchedule
      days
      execInterval
      execTime
      hourInterval
      executeOnHolidays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAlertLog = /* GraphQL */ `
  mutation CreateAlertLog(
    $input: CreateAlertLogInput!
    $condition: ModelAlertLogConditionInput
  ) {
    createAlertLog(input: $input, condition: $condition) {
      id
      alertID
      name
      description
      severity
      severityColor
      status
      companyID
      companyName
      branchID
      branchName
      deviceID
      deviceName
      notificationsSent
      recognizedByUser
      recognizedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAlertLog = /* GraphQL */ `
  mutation UpdateAlertLog(
    $input: UpdateAlertLogInput!
    $condition: ModelAlertLogConditionInput
  ) {
    updateAlertLog(input: $input, condition: $condition) {
      id
      alertID
      name
      description
      severity
      severityColor
      status
      companyID
      companyName
      branchID
      branchName
      deviceID
      deviceName
      notificationsSent
      recognizedByUser
      recognizedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAlertLog = /* GraphQL */ `
  mutation DeleteAlertLog(
    $input: DeleteAlertLogInput!
    $condition: ModelAlertLogConditionInput
  ) {
    deleteAlertLog(input: $input, condition: $condition) {
      id
      alertID
      name
      description
      severity
      severityColor
      status
      companyID
      companyName
      branchID
      branchName
      deviceID
      deviceName
      notificationsSent
      recognizedByUser
      recognizedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAlert = /* GraphQL */ `
  mutation CreateAlert(
    $input: CreateAlertInput!
    $condition: ModelAlertConditionInput
  ) {
    createAlert(input: $input, condition: $condition) {
      id
      name
      description
      severity
      severityColor
      devices {
        items {
          id
          alertId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      smsNotifications
      wspNotifications
      emailNotifications
      conditions
      enabled
      companyID
      startSchedule
      endSchedule
      days
      execInterval
      execTime
      hourInterval
      executeOnHolidays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAlert = /* GraphQL */ `
  mutation UpdateAlert(
    $input: UpdateAlertInput!
    $condition: ModelAlertConditionInput
  ) {
    updateAlert(input: $input, condition: $condition) {
      id
      name
      description
      severity
      severityColor
      devices {
        items {
          id
          alertId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      smsNotifications
      wspNotifications
      emailNotifications
      conditions
      enabled
      companyID
      startSchedule
      endSchedule
      days
      execInterval
      execTime
      hourInterval
      executeOnHolidays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAlert = /* GraphQL */ `
  mutation DeleteAlert(
    $input: DeleteAlertInput!
    $condition: ModelAlertConditionInput
  ) {
    deleteAlert(input: $input, condition: $condition) {
      id
      name
      description
      severity
      severityColor
      devices {
        items {
          id
          alertId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      smsNotifications
      wspNotifications
      emailNotifications
      conditions
      enabled
      companyID
      startSchedule
      endSchedule
      days
      execInterval
      execTime
      hourInterval
      executeOnHolidays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDeviceActionLog = /* GraphQL */ `
  mutation CreateDeviceActionLog(
    $input: CreateDeviceActionLogInput!
    $condition: ModelDeviceActionLogConditionInput
  ) {
    createDeviceActionLog(input: $input, condition: $condition) {
      id
      deviceID
      actionID
      userEmail
      actionName
      actionValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDeviceActionLog = /* GraphQL */ `
  mutation UpdateDeviceActionLog(
    $input: UpdateDeviceActionLogInput!
    $condition: ModelDeviceActionLogConditionInput
  ) {
    updateDeviceActionLog(input: $input, condition: $condition) {
      id
      deviceID
      actionID
      userEmail
      actionName
      actionValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDeviceActionLog = /* GraphQL */ `
  mutation DeleteDeviceActionLog(
    $input: DeleteDeviceActionLogInput!
    $condition: ModelDeviceActionLogConditionInput
  ) {
    deleteDeviceActionLog(input: $input, condition: $condition) {
      id
      deviceID
      actionID
      userEmail
      actionName
      actionValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDeviceAction = /* GraphQL */ `
  mutation CreateDeviceAction(
    $input: CreateDeviceActionInput!
    $condition: ModelDeviceActionConditionInput
  ) {
    createDeviceAction(input: $input, condition: $condition) {
      id
      deviceID
      actionID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDeviceAction = /* GraphQL */ `
  mutation UpdateDeviceAction(
    $input: UpdateDeviceActionInput!
    $condition: ModelDeviceActionConditionInput
  ) {
    updateDeviceAction(input: $input, condition: $condition) {
      id
      deviceID
      actionID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDeviceAction = /* GraphQL */ `
  mutation DeleteDeviceAction(
    $input: DeleteDeviceActionInput!
    $condition: ModelDeviceActionConditionInput
  ) {
    deleteDeviceAction(input: $input, condition: $condition) {
      id
      deviceID
      actionID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAction = /* GraphQL */ `
  mutation CreateAction(
    $input: CreateActionInput!
    $condition: ModelActionConditionInput
  ) {
    createAction(input: $input, condition: $condition) {
      id
      name
      shortName
      description
      valueType
      values
      errorMsg
      successMsg
      icon
      iconColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAction = /* GraphQL */ `
  mutation UpdateAction(
    $input: UpdateActionInput!
    $condition: ModelActionConditionInput
  ) {
    updateAction(input: $input, condition: $condition) {
      id
      name
      shortName
      description
      valueType
      values
      errorMsg
      successMsg
      icon
      iconColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAction = /* GraphQL */ `
  mutation DeleteAction(
    $input: DeleteActionInput!
    $condition: ModelActionConditionInput
  ) {
    deleteAction(input: $input, condition: $condition) {
      id
      name
      shortName
      description
      valueType
      values
      errorMsg
      successMsg
      icon
      iconColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserPreference = /* GraphQL */ `
  mutation CreateUserPreference(
    $input: CreateUserPreferenceInput!
    $condition: ModelUserPreferenceConditionInput
  ) {
    createUserPreference(input: $input, condition: $condition) {
      id
      userID
      dashboardStandard
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserPreference = /* GraphQL */ `
  mutation UpdateUserPreference(
    $input: UpdateUserPreferenceInput!
    $condition: ModelUserPreferenceConditionInput
  ) {
    updateUserPreference(input: $input, condition: $condition) {
      id
      userID
      dashboardStandard
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserPreference = /* GraphQL */ `
  mutation DeleteUserPreference(
    $input: DeleteUserPreferenceInput!
    $condition: ModelUserPreferenceConditionInput
  ) {
    deleteUserPreference(input: $input, condition: $condition) {
      id
      userID
      dashboardStandard
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDeviceVariable = /* GraphQL */ `
  mutation CreateDeviceVariable(
    $input: CreateDeviceVariableInput!
    $condition: ModelDeviceVariableConditionInput
  ) {
    createDeviceVariable(input: $input, condition: $condition) {
      id
      deviceID
      variableID
      calibrationFactor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDeviceVariable = /* GraphQL */ `
  mutation UpdateDeviceVariable(
    $input: UpdateDeviceVariableInput!
    $condition: ModelDeviceVariableConditionInput
  ) {
    updateDeviceVariable(input: $input, condition: $condition) {
      id
      deviceID
      variableID
      calibrationFactor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDeviceVariable = /* GraphQL */ `
  mutation DeleteDeviceVariable(
    $input: DeleteDeviceVariableInput!
    $condition: ModelDeviceVariableConditionInput
  ) {
    deleteDeviceVariable(input: $input, condition: $condition) {
      id
      deviceID
      variableID
      calibrationFactor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createVariable = /* GraphQL */ `
  mutation CreateVariable(
    $input: CreateVariableInput!
    $condition: ModelVariableConditionInput
  ) {
    createVariable(input: $input, condition: $condition) {
      id
      name
      description
      shortName
      derived
      unit
      groupType
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateVariable = /* GraphQL */ `
  mutation UpdateVariable(
    $input: UpdateVariableInput!
    $condition: ModelVariableConditionInput
  ) {
    updateVariable(input: $input, condition: $condition) {
      id
      name
      description
      shortName
      derived
      unit
      groupType
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteVariable = /* GraphQL */ `
  mutation DeleteVariable(
    $input: DeleteVariableInput!
    $condition: ModelVariableConditionInput
  ) {
    deleteVariable(input: $input, condition: $condition) {
      id
      name
      description
      shortName
      derived
      unit
      groupType
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSharedDashboard = /* GraphQL */ `
  mutation CreateSharedDashboard(
    $input: CreateSharedDashboardInput!
    $condition: ModelSharedDashboardConditionInput
  ) {
    createSharedDashboard(input: $input, condition: $condition) {
      id
      dashboardID
      userID
      permissions
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSharedDashboard = /* GraphQL */ `
  mutation UpdateSharedDashboard(
    $input: UpdateSharedDashboardInput!
    $condition: ModelSharedDashboardConditionInput
  ) {
    updateSharedDashboard(input: $input, condition: $condition) {
      id
      dashboardID
      userID
      permissions
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSharedDashboard = /* GraphQL */ `
  mutation DeleteSharedDashboard(
    $input: DeleteSharedDashboardInput!
    $condition: ModelSharedDashboardConditionInput
  ) {
    deleteSharedDashboard(input: $input, condition: $condition) {
      id
      dashboardID
      userID
      permissions
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDashboard = /* GraphQL */ `
  mutation CreateDashboard(
    $input: CreateDashboardInput!
    $condition: ModelDashboardConditionInput
  ) {
    createDashboard(input: $input, condition: $condition) {
      id
      name
      description
      chartDetails
      ownerID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDashboard = /* GraphQL */ `
  mutation UpdateDashboard(
    $input: UpdateDashboardInput!
    $condition: ModelDashboardConditionInput
  ) {
    updateDashboard(input: $input, condition: $condition) {
      id
      name
      description
      chartDetails
      ownerID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDashboard = /* GraphQL */ `
  mutation DeleteDashboard(
    $input: DeleteDashboardInput!
    $condition: ModelDashboardConditionInput
  ) {
    deleteDashboard(input: $input, condition: $condition) {
      id
      name
      description
      chartDetails
      ownerID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDevice = /* GraphQL */ `
  mutation CreateDevice(
    $input: CreateDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    createDevice(input: $input, condition: $condition) {
      id
      name
      location
      brand
      description
      companyID
      branchID
      coordsLat
      coordsLng
      timezone
      energyCost
      currency
      actionOnOff
      autoRefreshTime
      alerts {
        items {
          id
          alertId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rules {
        items {
          id
          ruleId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      actionsObj
      calibration
      env
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDevice = /* GraphQL */ `
  mutation UpdateDevice(
    $input: UpdateDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    updateDevice(input: $input, condition: $condition) {
      id
      name
      location
      brand
      description
      companyID
      branchID
      coordsLat
      coordsLng
      timezone
      energyCost
      currency
      actionOnOff
      autoRefreshTime
      alerts {
        items {
          id
          alertId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rules {
        items {
          id
          ruleId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      actionsObj
      calibration
      env
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDevice = /* GraphQL */ `
  mutation DeleteDevice(
    $input: DeleteDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    deleteDevice(input: $input, condition: $condition) {
      id
      name
      location
      brand
      description
      companyID
      branchID
      coordsLat
      coordsLng
      timezone
      energyCost
      currency
      actionOnOff
      autoRefreshTime
      alerts {
        items {
          id
          alertId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rules {
        items {
          id
          ruleId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      actionsObj
      calibration
      env
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      email
      sub
      roles {
        items {
          id
          userId
          roleId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      dashboards {
        items {
          id
          name
          description
          chartDetails
          ownerID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companyID
      isSuper
      name
      birthDate
      position
      sex
      gender
      phones
      additionalEmails
      addresses
      photoSrc
      isTechnician
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      email
      sub
      roles {
        items {
          id
          userId
          roleId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      dashboards {
        items {
          id
          name
          description
          chartDetails
          ownerID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companyID
      isSuper
      name
      birthDate
      position
      sex
      gender
      phones
      additionalEmails
      addresses
      photoSrc
      isTechnician
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      email
      sub
      roles {
        items {
          id
          userId
          roleId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      dashboards {
        items {
          id
          name
          description
          chartDetails
          ownerID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companyID
      isSuper
      name
      birthDate
      position
      sex
      gender
      phones
      additionalEmails
      addresses
      photoSrc
      isTechnician
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRole = /* GraphQL */ `
  mutation CreateRole(
    $input: CreateRoleInput!
    $condition: ModelRoleConditionInput
  ) {
    createRole(input: $input, condition: $condition) {
      id
      name
      description
      permissions {
        items {
          id
          roleId
          permissionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          userId
          roleId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRole = /* GraphQL */ `
  mutation UpdateRole(
    $input: UpdateRoleInput!
    $condition: ModelRoleConditionInput
  ) {
    updateRole(input: $input, condition: $condition) {
      id
      name
      description
      permissions {
        items {
          id
          roleId
          permissionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          userId
          roleId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRole = /* GraphQL */ `
  mutation DeleteRole(
    $input: DeleteRoleInput!
    $condition: ModelRoleConditionInput
  ) {
    deleteRole(input: $input, condition: $condition) {
      id
      name
      description
      permissions {
        items {
          id
          roleId
          permissionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          userId
          roleId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPermission = /* GraphQL */ `
  mutation CreatePermission(
    $input: CreatePermissionInput!
    $condition: ModelPermissionConditionInput
  ) {
    createPermission(input: $input, condition: $condition) {
      id
      name
      roles {
        items {
          id
          roleId
          permissionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePermission = /* GraphQL */ `
  mutation UpdatePermission(
    $input: UpdatePermissionInput!
    $condition: ModelPermissionConditionInput
  ) {
    updatePermission(input: $input, condition: $condition) {
      id
      name
      roles {
        items {
          id
          roleId
          permissionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePermission = /* GraphQL */ `
  mutation DeletePermission(
    $input: DeletePermissionInput!
    $condition: ModelPermissionConditionInput
  ) {
    deletePermission(input: $input, condition: $condition) {
      id
      name
      roles {
        items {
          id
          roleId
          permissionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBranch = /* GraphQL */ `
  mutation CreateBranch(
    $input: CreateBranchInput!
    $condition: ModelBranchConditionInput
  ) {
    createBranch(input: $input, condition: $condition) {
      id
      customId
      name
      abbreviation
      address
      phone
      description
      country
      city
      companyID
      devices {
        items {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBranch = /* GraphQL */ `
  mutation UpdateBranch(
    $input: UpdateBranchInput!
    $condition: ModelBranchConditionInput
  ) {
    updateBranch(input: $input, condition: $condition) {
      id
      customId
      name
      abbreviation
      address
      phone
      description
      country
      city
      companyID
      devices {
        items {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBranch = /* GraphQL */ `
  mutation DeleteBranch(
    $input: DeleteBranchInput!
    $condition: ModelBranchConditionInput
  ) {
    deleteBranch(input: $input, condition: $condition) {
      id
      customId
      name
      abbreviation
      address
      phone
      description
      country
      city
      companyID
      devices {
        items {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCompany = /* GraphQL */ `
  mutation CreateCompany(
    $input: CreateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    createCompany(input: $input, condition: $condition) {
      id
      name
      nit
      abbreviation
      address
      phone
      description
      legalRepName
      legalRepContact
      otherContacts
      branches {
        items {
          id
          customId
          name
          abbreviation
          address
          phone
          description
          country
          city
          companyID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      country
      city
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCompany = /* GraphQL */ `
  mutation UpdateCompany(
    $input: UpdateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    updateCompany(input: $input, condition: $condition) {
      id
      name
      nit
      abbreviation
      address
      phone
      description
      legalRepName
      legalRepContact
      otherContacts
      branches {
        items {
          id
          customId
          name
          abbreviation
          address
          phone
          description
          country
          city
          companyID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      country
      city
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany(
    $input: DeleteCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    deleteCompany(input: $input, condition: $condition) {
      id
      name
      nit
      abbreviation
      address
      phone
      description
      legalRepName
      legalRepContact
      otherContacts
      branches {
        items {
          id
          customId
          name
          abbreviation
          address
          phone
          description
          country
          city
          companyID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      country
      city
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createServiceOrderMaintenanceRoutine = /* GraphQL */ `
  mutation CreateServiceOrderMaintenanceRoutine(
    $input: CreateServiceOrderMaintenanceRoutineInput!
    $condition: ModelServiceOrderMaintenanceRoutineConditionInput
  ) {
    createServiceOrderMaintenanceRoutine(input: $input, condition: $condition) {
      id
      maintenanceRoutineId
      serviceOrderId
      maintenanceRoutine {
        id
        name
        description
        activities {
          nextToken
          __typename
        }
        companyID
        serviceOrders {
          nextToken
          __typename
        }
        activitiesOrder
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      serviceOrder {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        offline
        createdAt
        deletedAt
        slug
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateServiceOrderMaintenanceRoutine = /* GraphQL */ `
  mutation UpdateServiceOrderMaintenanceRoutine(
    $input: UpdateServiceOrderMaintenanceRoutineInput!
    $condition: ModelServiceOrderMaintenanceRoutineConditionInput
  ) {
    updateServiceOrderMaintenanceRoutine(input: $input, condition: $condition) {
      id
      maintenanceRoutineId
      serviceOrderId
      maintenanceRoutine {
        id
        name
        description
        activities {
          nextToken
          __typename
        }
        companyID
        serviceOrders {
          nextToken
          __typename
        }
        activitiesOrder
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      serviceOrder {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        offline
        createdAt
        deletedAt
        slug
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteServiceOrderMaintenanceRoutine = /* GraphQL */ `
  mutation DeleteServiceOrderMaintenanceRoutine(
    $input: DeleteServiceOrderMaintenanceRoutineInput!
    $condition: ModelServiceOrderMaintenanceRoutineConditionInput
  ) {
    deleteServiceOrderMaintenanceRoutine(input: $input, condition: $condition) {
      id
      maintenanceRoutineId
      serviceOrderId
      maintenanceRoutine {
        id
        name
        description
        activities {
          nextToken
          __typename
        }
        companyID
        serviceOrders {
          nextToken
          __typename
        }
        activitiesOrder
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      serviceOrder {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        offline
        createdAt
        deletedAt
        slug
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createServiceOrderTool = /* GraphQL */ `
  mutation CreateServiceOrderTool(
    $input: CreateServiceOrderToolInput!
    $condition: ModelServiceOrderToolConditionInput
  ) {
    createServiceOrderTool(input: $input, condition: $condition) {
      id
      toolId
      serviceOrderId
      tool {
        id
        name
        description
        location
        companyID
        technicianID
        serviceOrders {
          nextToken
          __typename
        }
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      serviceOrder {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        offline
        createdAt
        deletedAt
        slug
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateServiceOrderTool = /* GraphQL */ `
  mutation UpdateServiceOrderTool(
    $input: UpdateServiceOrderToolInput!
    $condition: ModelServiceOrderToolConditionInput
  ) {
    updateServiceOrderTool(input: $input, condition: $condition) {
      id
      toolId
      serviceOrderId
      tool {
        id
        name
        description
        location
        companyID
        technicianID
        serviceOrders {
          nextToken
          __typename
        }
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      serviceOrder {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        offline
        createdAt
        deletedAt
        slug
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteServiceOrderTool = /* GraphQL */ `
  mutation DeleteServiceOrderTool(
    $input: DeleteServiceOrderToolInput!
    $condition: ModelServiceOrderToolConditionInput
  ) {
    deleteServiceOrderTool(input: $input, condition: $condition) {
      id
      toolId
      serviceOrderId
      tool {
        id
        name
        description
        location
        companyID
        technicianID
        serviceOrders {
          nextToken
          __typename
        }
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      serviceOrder {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        offline
        createdAt
        deletedAt
        slug
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createServiceOrderEquipment = /* GraphQL */ `
  mutation CreateServiceOrderEquipment(
    $input: CreateServiceOrderEquipmentInput!
    $condition: ModelServiceOrderEquipmentConditionInput
  ) {
    createServiceOrderEquipment(input: $input, condition: $condition) {
      id
      serviceOrderId
      equipmentId
      serviceOrder {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        offline
        createdAt
        deletedAt
        slug
        updatedAt
        __typename
      }
      equipment {
        id
        name
        location
        description
        companyID
        branchID
        deviceID
        spares {
          nextToken
          __typename
        }
        serviceOrders {
          nextToken
          __typename
        }
        coordsLat
        coordsLng
        routineID
        equipmentTypeID
        deletedAt
        slug
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateServiceOrderEquipment = /* GraphQL */ `
  mutation UpdateServiceOrderEquipment(
    $input: UpdateServiceOrderEquipmentInput!
    $condition: ModelServiceOrderEquipmentConditionInput
  ) {
    updateServiceOrderEquipment(input: $input, condition: $condition) {
      id
      serviceOrderId
      equipmentId
      serviceOrder {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        offline
        createdAt
        deletedAt
        slug
        updatedAt
        __typename
      }
      equipment {
        id
        name
        location
        description
        companyID
        branchID
        deviceID
        spares {
          nextToken
          __typename
        }
        serviceOrders {
          nextToken
          __typename
        }
        coordsLat
        coordsLng
        routineID
        equipmentTypeID
        deletedAt
        slug
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteServiceOrderEquipment = /* GraphQL */ `
  mutation DeleteServiceOrderEquipment(
    $input: DeleteServiceOrderEquipmentInput!
    $condition: ModelServiceOrderEquipmentConditionInput
  ) {
    deleteServiceOrderEquipment(input: $input, condition: $condition) {
      id
      serviceOrderId
      equipmentId
      serviceOrder {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        offline
        createdAt
        deletedAt
        slug
        updatedAt
        __typename
      }
      equipment {
        id
        name
        location
        description
        companyID
        branchID
        deviceID
        spares {
          nextToken
          __typename
        }
        serviceOrders {
          nextToken
          __typename
        }
        coordsLat
        coordsLng
        routineID
        equipmentTypeID
        deletedAt
        slug
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRuleDevice = /* GraphQL */ `
  mutation CreateRuleDevice(
    $input: CreateRuleDeviceInput!
    $condition: ModelRuleDeviceConditionInput
  ) {
    createRuleDevice(input: $input, condition: $condition) {
      id
      ruleId
      deviceId
      rule {
        id
        name
        description
        action
        actionValue
        devices {
          nextToken
          __typename
        }
        smsNotifications
        wspNotifications
        emailNotifications
        conditions
        enabled
        companyID
        startSchedule
        endSchedule
        days
        execInterval
        execTime
        hourInterval
        executeOnHolidays
        createdAt
        updatedAt
        __typename
      }
      device {
        id
        name
        location
        brand
        description
        companyID
        branchID
        coordsLat
        coordsLng
        timezone
        energyCost
        currency
        actionOnOff
        autoRefreshTime
        alerts {
          nextToken
          __typename
        }
        rules {
          nextToken
          __typename
        }
        actionsObj
        calibration
        env
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRuleDevice = /* GraphQL */ `
  mutation UpdateRuleDevice(
    $input: UpdateRuleDeviceInput!
    $condition: ModelRuleDeviceConditionInput
  ) {
    updateRuleDevice(input: $input, condition: $condition) {
      id
      ruleId
      deviceId
      rule {
        id
        name
        description
        action
        actionValue
        devices {
          nextToken
          __typename
        }
        smsNotifications
        wspNotifications
        emailNotifications
        conditions
        enabled
        companyID
        startSchedule
        endSchedule
        days
        execInterval
        execTime
        hourInterval
        executeOnHolidays
        createdAt
        updatedAt
        __typename
      }
      device {
        id
        name
        location
        brand
        description
        companyID
        branchID
        coordsLat
        coordsLng
        timezone
        energyCost
        currency
        actionOnOff
        autoRefreshTime
        alerts {
          nextToken
          __typename
        }
        rules {
          nextToken
          __typename
        }
        actionsObj
        calibration
        env
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRuleDevice = /* GraphQL */ `
  mutation DeleteRuleDevice(
    $input: DeleteRuleDeviceInput!
    $condition: ModelRuleDeviceConditionInput
  ) {
    deleteRuleDevice(input: $input, condition: $condition) {
      id
      ruleId
      deviceId
      rule {
        id
        name
        description
        action
        actionValue
        devices {
          nextToken
          __typename
        }
        smsNotifications
        wspNotifications
        emailNotifications
        conditions
        enabled
        companyID
        startSchedule
        endSchedule
        days
        execInterval
        execTime
        hourInterval
        executeOnHolidays
        createdAt
        updatedAt
        __typename
      }
      device {
        id
        name
        location
        brand
        description
        companyID
        branchID
        coordsLat
        coordsLng
        timezone
        energyCost
        currency
        actionOnOff
        autoRefreshTime
        alerts {
          nextToken
          __typename
        }
        rules {
          nextToken
          __typename
        }
        actionsObj
        calibration
        env
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAlertDevice = /* GraphQL */ `
  mutation CreateAlertDevice(
    $input: CreateAlertDeviceInput!
    $condition: ModelAlertDeviceConditionInput
  ) {
    createAlertDevice(input: $input, condition: $condition) {
      id
      alertId
      deviceId
      alert {
        id
        name
        description
        severity
        severityColor
        devices {
          nextToken
          __typename
        }
        smsNotifications
        wspNotifications
        emailNotifications
        conditions
        enabled
        companyID
        startSchedule
        endSchedule
        days
        execInterval
        execTime
        hourInterval
        executeOnHolidays
        createdAt
        updatedAt
        __typename
      }
      device {
        id
        name
        location
        brand
        description
        companyID
        branchID
        coordsLat
        coordsLng
        timezone
        energyCost
        currency
        actionOnOff
        autoRefreshTime
        alerts {
          nextToken
          __typename
        }
        rules {
          nextToken
          __typename
        }
        actionsObj
        calibration
        env
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAlertDevice = /* GraphQL */ `
  mutation UpdateAlertDevice(
    $input: UpdateAlertDeviceInput!
    $condition: ModelAlertDeviceConditionInput
  ) {
    updateAlertDevice(input: $input, condition: $condition) {
      id
      alertId
      deviceId
      alert {
        id
        name
        description
        severity
        severityColor
        devices {
          nextToken
          __typename
        }
        smsNotifications
        wspNotifications
        emailNotifications
        conditions
        enabled
        companyID
        startSchedule
        endSchedule
        days
        execInterval
        execTime
        hourInterval
        executeOnHolidays
        createdAt
        updatedAt
        __typename
      }
      device {
        id
        name
        location
        brand
        description
        companyID
        branchID
        coordsLat
        coordsLng
        timezone
        energyCost
        currency
        actionOnOff
        autoRefreshTime
        alerts {
          nextToken
          __typename
        }
        rules {
          nextToken
          __typename
        }
        actionsObj
        calibration
        env
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAlertDevice = /* GraphQL */ `
  mutation DeleteAlertDevice(
    $input: DeleteAlertDeviceInput!
    $condition: ModelAlertDeviceConditionInput
  ) {
    deleteAlertDevice(input: $input, condition: $condition) {
      id
      alertId
      deviceId
      alert {
        id
        name
        description
        severity
        severityColor
        devices {
          nextToken
          __typename
        }
        smsNotifications
        wspNotifications
        emailNotifications
        conditions
        enabled
        companyID
        startSchedule
        endSchedule
        days
        execInterval
        execTime
        hourInterval
        executeOnHolidays
        createdAt
        updatedAt
        __typename
      }
      device {
        id
        name
        location
        brand
        description
        companyID
        branchID
        coordsLat
        coordsLng
        timezone
        energyCost
        currency
        actionOnOff
        autoRefreshTime
        alerts {
          nextToken
          __typename
        }
        rules {
          nextToken
          __typename
        }
        actionsObj
        calibration
        env
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRoleUser = /* GraphQL */ `
  mutation CreateRoleUser(
    $input: CreateRoleUserInput!
    $condition: ModelRoleUserConditionInput
  ) {
    createRoleUser(input: $input, condition: $condition) {
      id
      userId
      roleId
      user {
        id
        email
        sub
        roles {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        companyID
        isSuper
        name
        birthDate
        position
        sex
        gender
        phones
        additionalEmails
        addresses
        photoSrc
        isTechnician
        createdAt
        updatedAt
        __typename
      }
      role {
        id
        name
        description
        permissions {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        companyID
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRoleUser = /* GraphQL */ `
  mutation UpdateRoleUser(
    $input: UpdateRoleUserInput!
    $condition: ModelRoleUserConditionInput
  ) {
    updateRoleUser(input: $input, condition: $condition) {
      id
      userId
      roleId
      user {
        id
        email
        sub
        roles {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        companyID
        isSuper
        name
        birthDate
        position
        sex
        gender
        phones
        additionalEmails
        addresses
        photoSrc
        isTechnician
        createdAt
        updatedAt
        __typename
      }
      role {
        id
        name
        description
        permissions {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        companyID
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRoleUser = /* GraphQL */ `
  mutation DeleteRoleUser(
    $input: DeleteRoleUserInput!
    $condition: ModelRoleUserConditionInput
  ) {
    deleteRoleUser(input: $input, condition: $condition) {
      id
      userId
      roleId
      user {
        id
        email
        sub
        roles {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        companyID
        isSuper
        name
        birthDate
        position
        sex
        gender
        phones
        additionalEmails
        addresses
        photoSrc
        isTechnician
        createdAt
        updatedAt
        __typename
      }
      role {
        id
        name
        description
        permissions {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        companyID
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRolePermission = /* GraphQL */ `
  mutation CreateRolePermission(
    $input: CreateRolePermissionInput!
    $condition: ModelRolePermissionConditionInput
  ) {
    createRolePermission(input: $input, condition: $condition) {
      id
      roleId
      permissionId
      role {
        id
        name
        description
        permissions {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        companyID
        createdAt
        updatedAt
        __typename
      }
      permission {
        id
        name
        roles {
          nextToken
          __typename
        }
        description
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRolePermission = /* GraphQL */ `
  mutation UpdateRolePermission(
    $input: UpdateRolePermissionInput!
    $condition: ModelRolePermissionConditionInput
  ) {
    updateRolePermission(input: $input, condition: $condition) {
      id
      roleId
      permissionId
      role {
        id
        name
        description
        permissions {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        companyID
        createdAt
        updatedAt
        __typename
      }
      permission {
        id
        name
        roles {
          nextToken
          __typename
        }
        description
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRolePermission = /* GraphQL */ `
  mutation DeleteRolePermission(
    $input: DeleteRolePermissionInput!
    $condition: ModelRolePermissionConditionInput
  ) {
    deleteRolePermission(input: $input, condition: $condition) {
      id
      roleId
      permissionId
      role {
        id
        name
        description
        permissions {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        companyID
        createdAt
        updatedAt
        __typename
      }
      permission {
        id
        name
        roles {
          nextToken
          __typename
        }
        description
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
